import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/constants";

// Procesa el session_id que devuelve el login social de Google (Emergent-managed).
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      const r = await googleSession(sessionId);
      // Limpia el fragmento de la URL
      window.history.replaceState(null, "", window.location.pathname);
      if (r.ok) navigate("/", { replace: true });
      else setError(r.error || "No se pudo iniciar sesión con Google.");
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4 text-center px-6">
        <img src={LOGO_URL} alt="ConstruLink" className="h-14 w-auto max-w-[240px] object-contain" />
        {error ? (
          <>
            <p className="text-brand-red font-semibold" data-testid="auth-callback-error">{error}</p>
            <button onClick={() => navigate("/login", { replace: true })} className="text-sm font-semibold text-brand-blue hover:underline">
              Volver a iniciar sesión
            </button>
          </>
        ) : (
          <>
            <Loader2 size={28} className="animate-spin text-brand-blue" />
            <p className="text-slate-500 font-medium">Conectando con Google…</p>
          </>
        )}
      </div>
    </div>
  );
}
